import axios from 'axios';
import _ from 'lodash';
import { toQueryString } from '../../helpers';

export const state = {
  bOrders: [],
  bOrdersPagination: {
    currentPage: 1,
    from: 0,
    to: 25,
  },
  loading: false,
};

export const mutations = {
  setBOrders(context, bOrders) {
    context.bOrders = bOrders;
    context.loading = false;
  },

  setPagination(context, pagination) {
    context.bOrdersPagination = pagination;
  },

  setBOrder(context, bOrder) {
    const { bOrders } = context;
    const index = _.findIndex(bOrders, { id: bOrder.id });

    if (index === -1) {
      bOrders.push(bOrder);
    } else {
      bOrders[index] = bOrder;
    }

    context.bOrders = bOrders;
    context.loading = false;
  },

  deleteBOrder(context, id) {
    context.bOrders = context.bOrders.filter(bOrder => bOrder.id !== id);
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getBOrders({ commit, rootState }, params) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      const query = params ? `?${params}` : '';

      commit('setLoading', true);

      const bOrders = await axios.get(`${window.BASE_API.ORDERING}/orders${query}`, options)
        .then(response => response.data);

      commit('setPagination', bOrders.pagination);
      commit('setBOrders', bOrders.result);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async getAllBOrders({ rootState }, params) {
    const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
    const options = {
      headers: {
        Authorization: jwtToken,
      },
    };
    Object.assign(params, { per_page: -1 });

    const query = toQueryString(params);

    const bOrders = await axios.get(`${window.BASE_API.ORDERING}/orders?${query}`, options);

    return bOrders.data.result;
  },

  putBOrder({ commit, dispatch, rootState }, data) {
    const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
    const options = {
      headers: {
        Authorization: jwtToken,
      },
    };
    let url = `${window.BASE_API.ORDERING}/orders`;

    commit('setLoading', true);

    if (data.id) {
      url += `/${data.id}`;
    }

    return axios.put(url, data, options)
      .then(() => dispatch('getBOrders'))
      .catch(() => commit('setLoading', false));
  },
  async processOrders({ commit, rootState }, data) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      await axios.post(`${window.BASE_API.ORDERING}/processNextOrder`, data.data, options)
        .then(response => response.data.result);

      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const bOrdersStore = {
  state,
  mutations,
  actions,
};

export default bOrdersStore;



// WEBPACK FOOTER //
// ./src/store/blockchainOrders/blockchainOrderStore.js